import LazyLoad from "react-lazyload"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { useState } from "react"
import PlayButton from "components/YoutubeLazy/PlayButton"
import YoutubeVideo from "components/YoutubeVideo"
import { color } from "helpers/styled"

const background = css`
  background: linear-gradient(-10deg, transparent 50.5%, ${color("darkBlue")}99 51.5%), ${color("mediumBlue")};
`

const PlaceholderWrap = styled.div`
  position: relative;
  margin: auto;
  cursor: pointer;
  ${background};

  &:before {
    content: "";
    display: block;
    width: 100%;
    height: 0;
    padding-bottom: ${(9 / 16) * 100}%;
  }
`

const Placeholder = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export default function YoutubeLazy({ videoId, autoPlay, handleLoad, handlePlay, className, videoRef }) {
  const [loaded, setLoaded] = useState(false)

  const imageUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`

  const handleReady = e => {
    if (autoPlay) e.target.playVideo()
    // eslint-disable-next-line no-param-reassign
    if (videoRef) videoRef.current = e.target
  }

  if (!loaded)
    return (
      <PlaceholderWrap
        className={className}
        onClick={e => {
          if (!e.defaultPrevented) {
            setLoaded(true)
            handleLoad()
          }
        }}>
        <LazyLoad once>
          <Placeholder src={imageUrl} />
        </LazyLoad>
        <PlayButton parent={PlaceholderWrap} />
      </PlaceholderWrap>
    )

  return (
    <YoutubeVideo
      youtubeId={videoId}
      onReady={handleReady}
      onPlay={handlePlay}
      className={className}
      css={background}
    />
  )
}

YoutubeLazy.defaultProps = {
  autoPlay: false,
  handleLoad: () => {},
  handlePlay: () => {},
  className: null,
  videoRef: null
}

YoutubeLazy.propTypes = {
  videoId: PropTypes.string.isRequired,
  autoPlay: PropTypes.bool,
  handleLoad: PropTypes.func,
  handlePlay: PropTypes.func,
  className: PropTypes.string,
  videoRef: PropTypes.object
}
